import React, { useState } from 'react';
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const BookingButton = () => {
  const [showPopup, setShowPopup] = useState(false);

  const whatsappLink = `https://wa.me/971585719601?text=I'm%20interested%20in%20booking`;
  const emailLink = `mailto:atwtourismuae@gmail.com?subject=Booking%20Request&body=I'm%20interested%20in%20booking.`;

  return (
    <div className="relative inline-block text-center">
      {/* Book Now Button */}
      <button
        onClick={() => setShowPopup(true)}
        className="bg-gradient-to-r from-blue-600 to-green-500 text-white px-5 py-2 rounded-full font-medium shadow-md hover:shadow-xl transform hover:scale-105 transition-all duration-300 ease-in-out text-sm"
      >
        Book Now
      </button>

      {/* Popup Modal */}
      {showPopup && (
        <div className="absolute top-full mt-4 left-1/2 -translate-x-1/2 sm:left-auto sm:right-0 sm:translate-x-0 bg-white border border-gray-200 rounded-xl shadow-lg p-5 w-72 z-50">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">Choose a contact method</h3>
          <div className="space-y-3">
            {/* WhatsApp Button */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-green-500 text-white px-4 py-2 rounded-full font-medium hover:bg-green-600 transition"
            >
              <FaWhatsapp size={18} />
              WhatsApp
            </a>

            {/* Email Button */}
            <a
              href={emailLink}
              className="flex items-center justify-center gap-2 bg-red-500 text-white px-4 py-2 rounded-full font-medium hover:bg-red-600 transition"
            >
              <FaEnvelope size={18} />
              Email
            </a>

            {/* Cancel Button */}
            <button
              onClick={() => setShowPopup(false)}
              className="text-sm text-gray-500 mt-2 hover:font-bold transition rounded-full"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingButton;
